if (!customElements.get('product-video')) {
  customElements.define(
    "product-video",
    class ProductVideo extends HTMLElement {
      constructor() {
        super();
        // Check for presence of getVideoId() on window and load if not present
        this.getVideoIdPromise = new Promise((resolve, reject) => {
          if (window.getVideoId) {
            console.log('getVideoId found');
            resolve();
          } else {
            console.log("getVideoId not found, loading script");
            this.loadScriptAsync(
              "https://cdn.jsdelivr.net/npm/get-video-id/dist/get-video-id.umd.min.js",
              "getVideoId",
              "getVideoId"
            )
              .then(() => {
                console.log("getVideoId loaded");
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          }
        });
      }

      async connectedCallback() {
        try {
          await this.getVideoIdPromise;

          // Initialize variables
          this.videoMount = this.querySelector(".js-video-mount");
          this.videoWrapper = this.querySelector(".js-video-wrapper");
          this.cloak = this.querySelector(".js-video-cloak");
          this.loadButton = this.querySelector(".js-video-load-button");
          this.videoPoster = this.hasAttribute("data-video-poster");
          // Grab video url to parse
          this.videoUrl = this.getAttribute("data-video-url");
          // Parsed Youtube or Vimeo Video ID
          this.videoId = getVideoId(this.videoUrl).id;
          // Parsed Video Service
          this.videoService = getVideoId(this.videoUrl).service;

          if (this.videoService === "youtube" && !window.YT) {
            this.loadScriptAsync(
              "https://www.youtube.com/iframe_api",
              "youtube-iframe-api",
              "youtube-iframe-api"
            );
          }

          // parseable because the functions don't like 'this'
          const videoMount = this.videoMount;
          const onPlayerStateChange = this.onPlayerStateChange;
          const videoId = this.videoId;

          if (this.videoService === "youtube") {
            var player;

            window.onYouTubeIframeAPIReady = function () {
              player = new window.YT.Player(videoMount, {
                height: "390",
                width: "640",
                playerVars: {
                  playsinline: 0,
                  rel: 0,
                  enablejsapi: 1,
                  modestbranding: 1,
                },
                events: {
                  onStateChange: onPlayerStateChange,
                },
              });
            };

            this.loadButton.addEventListener("click", (e) => {
              e.preventDefault();
              this.loadButton.classList.add("is-animating");
              player.cueVideoById(videoId);
              setInterval(() => {
                if (player.getPlayerState() === 5) {
                  player.playVideo();
                }
              }, 500);
            });
            // player.on('unstarted', () => {
            //   this.classList.add('is-loaded');
            //   this.videoWrapper.classList.remove('is-hidden');
            //   this.loadButton.classList.remove('is-animating');
            //   player.play();
            // });
            // player.on("ended", () => {
            //   this.classList.remove("is-loaded");
            //   this.videoWrapper.classList.add("is-hidden");
            // });
            // if (this.cloak !== null) {
            //   this.cloak.addEventListener('click', (e) => {
            //     e.preventDefault();

            //     player.pause();
            //     this.classList.remove('is-loaded');
            //     this.videoWrapper.classList.add('is-hidden');
            //   });
            // }
          }
          // Do these things if it's a Vimeo video
          if (this.videoService === "vimeo") {
            console.error("Vimeo videos are not supported yet");
            this.classList.add("is-hidden");
            // const player = new VimeoPlayer(this.videoMount);

            // this.loadButton.addEventListener('click', (e) => {
            //   e.preventDefault();
            //   this.loadButton.classList.add('is-animating');
            //   player.loadVideo(this.videoId);
            // });

            // player.on('loaded', () => {
            //   this.classList.add('is-loaded');
            //   this.videoWrapper.classList.remove('is-hidden');
            //   this.loadButton.classList.remove('is-animating');
            //   player.play();
            // });

            // if (this.cloak !== null) {
            //   this.cloak.addEventListener('click', (e) => {
            //     e.preventDefault();

            //     player.pause();
            //     this.classList.remove('is-loaded');
            //     this.videoWrapper.classList.add('is-hidden');
            //   });
            // }

            // player.on('ended', () => {
            //   this.classList.remove('is-loaded');
            //   this.videoWrapper.classList.add('is-hidden');
            // });
          }
          // Hide the video node and log error if neither youtube or vimeo.
          if (
            this.videoService !== "youtube" &&
            this.videoService !== "vimeo"
          ) {
            this.classList.add("is-hidden");
            console.error(
              "video url is malformed, or the video service is not supported"
            );
          }
        } catch (error) {
          this.classList.add("is-hidden");
          console.error(error);
        }
      }

      loadScriptAsync(uri, id, scriptName = "script") {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = uri;
          script.async = true;
          script.id = id;
          script.onload = () => {
            resolve(`${scriptName} successfully loaded`);
          };
          document.body.append(script);
        });
      }

      onPlayerStateChange(event) {
        const thisNode = event.target.getIframe().parentNode.parentNode;
        const videoWrapper = thisNode.querySelector(".js-video-wrapper");
        const loadButton = thisNode.querySelector(".js-video-load-button");

        if (event.data === YT.PlayerState.CUED) {
          thisNode.classList.add("is-loaded");
          videoWrapper.classList.remove("is-hidden");
          videoWrapper.classList.remove("is-playing");
          loadButton.classList.remove("is-animating");
        }
        if (event.data === YT.PlayerState.PLAYING) {
          videoWrapper.classList.add("is-playing");
        }
        if (event.data === YT.PlayerState.ENDED) {
          thisNode.classList.remove("is-loaded");
          videoWrapper.classList.remove("is-playing");
          console.log("VIDEO OVER");
        }
      }

      disconnectedCallback() {
        console.log("disconnected");
      }
    }
  );
};